export default {
  created () {
    this.singleActions = [
      {
        label: this.$t('table.action.delete'),
        permission: 'bastion_servers_delete',
        action: (obj) => {
          this.createDialog('BastionServersDeleteDialog', {
            vm: this,
            data: [obj],
            columns: this.columns,
            title: this.$t('table.action.delete'),
            name: this.$t('dictionary.server'),
            success: () => {
              setTimeout(() => {
                this.list.refresh()
              }, 1000)
            },
          })
        },
      },
    ]
  },
}
